import React from "react";
import styled, { css } from "styled-components";
import { OverlayTrigger, Icon, ClipboardIconButton, Spinner } from "components/common";
import BasicQueryInput from "views/components/searchbar/queryinput/BasicQueryInput";
import useSearchFiltersFormState from "search-filter/hooks/useSearchFiltersFormState";
import useCurrentQueryString from "search-filter/hooks/useCurrentQueryString";
import useEffectiveQuery from "search-filter/hooks/useEffectiveQuery";
const StyledIcon = styled(Icon)(
  ({ theme }) => css`
    margin-left: ${theme.spacings.xs};
    cursor: pointer;
  `
);
const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const Content = styled.div`
  min-width: 250px;
`;
const useCurrentEffectiveQuery = () => {
  const selectedFilters = useSearchFiltersFormState();
  const queryString = useCurrentQueryString();
  return useEffectiveQuery(queryString, selectedFilters);
};
const OverlayTitle = () => {
  const { effectiveQuery, isFetching } = useCurrentEffectiveQuery();
  return /* @__PURE__ */ React.createElement(TitleRow, null, "Full Query", /* @__PURE__ */ React.createElement(ClipboardIconButton, { text: effectiveQuery, buttonTitle: "Copy query", disabled: isFetching || !effectiveQuery }));
};
const OverlayBody = () => {
  const { effectiveQuery, isFetching } = useCurrentEffectiveQuery();
  return /* @__PURE__ */ React.createElement(Content, null, isFetching ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(BasicQueryInput, { disabled: true, value: effectiveQuery, maxLines: 10, wrapEnabled: true, inputId: "effective-query-preview" }));
};
const EffectiveQueryOverlay = () => {
  const selectedFilters = useSearchFiltersFormState();
  if (!(selectedFilters == null ? void 0 : selectedFilters.size)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    OverlayTrigger,
    {
      placement: "bottom",
      width: 700,
      triggerTitle: "Show full query",
      title: /* @__PURE__ */ React.createElement(OverlayTitle, null),
      overlay: /* @__PURE__ */ React.createElement(OverlayBody, null),
      testId: "effective-query-overlay"
    },
    /* @__PURE__ */ React.createElement(StyledIcon, { name: "visibility", "data-testid": "effective-query-trigger" })
  );
};
export default EffectiveQueryOverlay;
